import moment from 'moment-timezone';
import {RELATIONSHIP_TYPE, status} from '../../../utils/constant';
import {invitationsInDb} from './data/invitation';
import {convertTokenFromAPI} from '../helper';
import FakeNetworkEnrollmentService from './FakeNetworkEnrollmentService';
import FakeProjectEnrollmentService from './FakeProjectEnrollmentService';

function decodeToken(_token) {
  return Promise.resolve(invitationsInDb[0])
    .then(response => response.json())
    .then(response => convertTokenFromAPI(response));
}

function createAccessCode(_organisationSourceId, invitation) {
  invitationsInDb.push({
    ...invitation,
    creationDate: moment().format('YYYY-MM-DDTHH:mm:ss'),
    relationshipType: RELATIONSHIP_TYPE.SUB_CONTRACTOR_OF,
    isAccessCodeInvitation: true
  });
  return new Promise(resolve => {
    setTimeout(() => resolve(), 0);
  });
}

function downloadAccessCode() {
  return 'https://github.com/AttestationLegale/front-onceforall/archive/dev.zip';
}

function addSubcontractorViaAccessCode() {
  return Promise.resolve({});
}

function inviteUser() {
  return Promise.resolve({});
}

function pendingInvitationExists(invitationId) {
  return Promise.all([
    FakeNetworkEnrollmentService.pendingInvitationExists(invitationId),
    FakeProjectEnrollmentService.pendingInvitationExists(invitationId)
  ])
    .then(([networkInvitationExists, projectInvitationExists]) => networkInvitationExists || projectInvitationExists);
}

function pendingOrAcceptedInvitationAsSubcontractorExists(country, registrationNumber, vatIdentificationNumber) {
  // The backend returns a 204 status code when such an invitation exists, and a 404 status code otherwise.
  return Promise.resolve(invitationsInDb.some(invitation => ((invitation.status === status.PENDING) || (invitation.status === status.ACCEPTED)) &&
        (invitation.country === country) &&
        (invitation.registrationNumber === registrationNumber || invitation.vatIdentificationNumber === vatIdentificationNumber) &&
        (((invitation.invitationType === 'NETWORK') && (invitation.relationshipType === RELATIONSHIP_TYPE.SUB_CONTRACTOR_OF)) ||
        ((invitation.invitationType === 'PROJECT') && (invitation.project.targetRole !== 'CLIENT')))));
}

export default {
  decodeToken,
  createAccessCode,
  downloadAccessCode,
  addSubcontractorViaAccessCode,
  inviteUser,
  pendingInvitationExists,
  pendingOrAcceptedInvitationAsSubcontractorExists
};
